import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Image } from 'primereact/image';

import PFWhiteLogo from '../../../../assets/images/PFLogo.jpg';
import { clientDetails } from '../../../../constants';
import styles from '../css/navbar.module.css';

const CompanyLogo = () => {
  const history = useHistory();
  const [imgError, setImgError] = useState(false);
  const hasClientLogo = !!clientDetails?.logo && !imgError;

  const handleLogoError = () => setImgError(true);

  const handleNavigation = () => {
    history.push('/dashboard');
  };
  return (
    <div className="col-12 md:col lg:col-fixed flex align-items-center lg:w-auto">
      <div className={`w-2rem mt-2 ${styles.mobileHumburger}`} />

      {hasClientLogo ? (
        <>
          <Image
            alt={clientDetails?.client_name}
            preview={false}
            src={decodeURIComponent(clientDetails.logo)}
            onError={handleLogoError}
            className="mx-3 md:mx-2 max-h-4rem max-w-7rem cursor-pointer flex"
            onClick={() => history.push('/dashboard')}
            pt={{
              image: { className: 'max-w-5rem md:max-w-7rem max-h-4rem' },
            }}
          />
        </>
      ) : (
        <>
          <Image
            alt="Projects Force"
            src={PFWhiteLogo}
            preview={false}
            className="ml-2 cursor-pointer"
            onClick={handleNavigation}
            pt={{
              image: { className: 'p-1 max-w-7rem w-7rem max-h-3rem' },
            }}
          />
        </>
      )}

      {/* Company Text */}
      <div className="flex flex-column">
        <div className="h-2rem flex align-items-center">
          <div className="flex justify-content-center align-itemx-center mr-2">
            <div>
              <p className="typing-text text-sm xl:text-md">
                {clientDetails?.client_name}
              </p>
            </div>
          </div>
        </div>

        <div className="w-12 -mt-1 text-10 mr-2">
          <span className="text-gray-600">Powered by </span>
          <span className="text-primary">ProjectsForce 360°</span>
        </div>
      </div>
    </div>
  );
};

export default CompanyLogo;
